import { RefObject } from 'react';

// Components
import { ImageFallback } from '@shared/ui';

// Constants
import { FALLBACK_SRC } from '@shared/constants';

// Utils
import { combineClasses } from '@shared/utils';

// Types
import { UserProfile } from '@/types';

// Helpers
import { getUserMentionText, isUserDeactivated } from './helpers';
interface UserMentionItemProps {
  user: UserProfile;
  index: number;
  isSelected: boolean;
  selectedUserRef: RefObject<HTMLButtonElement | null>;
  onUserSelect: (user: UserProfile) => void;
}
export const UserMentionItem = ({
  user,
  index,
  isSelected,
  selectedUserRef,
  onUserSelect
}: UserMentionItemProps) => {
  const isDeactivated = isUserDeactivated(user.status);
  const displayName = getUserMentionText(user);
  const handleUserClick = () => {
    onUserSelect(user);
  };
  return <button data-testid={`user-mention-item-${index}`} key={user.id} ref={isSelected ? selectedUserRef : null} tabIndex={-1} role="option" aria-selected={isSelected} aria-label={`Select user ${displayName}${isDeactivated ? ' (deactivated)' : ''}`} aria-describedby={isDeactivated ? `user-status-${index}` : undefined} className={combineClasses('w-full flex items-center gap-3.5 p-3 text-left', 'h-12 hover:bg-primary-100 transition-colors', 'first:rounded-t-lg last:rounded-b-lg', isSelected && 'bg-primary-100')} onClick={handleUserClick} data-sentry-component="UserMentionItem" data-sentry-source-file="UserMentionItem.tsx">
      <div className="relative" data-testid={`user-avatar-${index}`}>
        <ImageFallback src={user.avatar || FALLBACK_SRC.AVATAR} fallbackSrc={FALLBACK_SRC.AVATAR} alt={`${displayName}'s avatar`} width={30} height={30} className={combineClasses('rounded-full object-cover', isDeactivated && 'grayscale')} data-sentry-element="ImageFallback" data-sentry-source-file="UserMentionItem.tsx" />
      </div>
      <div className="flex-1 min-w-0" data-testid={`user-info-${index}`}>
        <div className="flex items-center justify-between gap-2">
          <span data-testid={`user-name-${index}`} className={combineClasses('text-base font-normal truncate', isDeactivated ? 'text-frost-500' : 'text-black')}>
            {displayName}
          </span>
          {isDeactivated && <span className="text-xs text-frost-500" data-testid={`user-status-${index}`} id={`user-status-${index}`} aria-label="User is deactivated">
              Deactivated
            </span>}
        </div>
      </div>
    </button>;
};